import { Helmet } from "react-helmet-async";

const SITE = "https://slatechsolutions.com";
const OG_IMAGE = `${SITE}/logo-slatech.png`;

export const Seo = ({
  title,
  description,
  path = "/",
}) => {
  const fullTitle = title
    ? `${title} | Slatech Solutions`
    : "Slatech Solutions | Industrial Solutions & Business Development";
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Slatech Solutions" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};
